const initialState = {

	producers : {},
	consumers : {}
};

const transports = (state = initialState, action) =>
{
	switch (action.type)
	{
		case 'ADD_TRANSPORT_STATS':
		{
			const { transport, type } = action.payload;

			return { ...state, [type]: transport[0] };
		}

		case 'ADD_PRODUCER_STATS':
		{
			const { producer, type } = action.payload;

			const  oldProducers = state['producers'];

			const newProducers = { 
				...oldProducers, 
				[type]: producer 
			};
			
			return { ...state, producers: newProducers };
		}

		case 'ADD_CONSUMER_STATS':
		{
			const { consumer, id } = action.payload;

			let oldConsumers = state['consumers'];

			const newConsumers = {
				...oldConsumers,
				[id] : consumer
			};

			return { ...state, consumers: newConsumers };
		}

		default:
			return state;
	}
};

export default transports;
